const Config = window.zuadConfig;

export default Config;
